module.exports = __webpack_public_path__ + "assets/b3270c6e29d43a62af5b213ff77a94fa.json";